module.exports = __webpack_public_path__ + "images/emoji/droplet.a5e8161908ecc8a8f91a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/droplet.png
// module id = epDZ
// module chunks = 13